export default __webpack_public_path__ + "static/media/contact.cecbdc75.JPG";